module.exports = __webpack_public_path__ + "static/img/img_7.0d563cb1.jpg";